/* The marketing site in the October 2026 brand: what templates/brand.html needs to move.

   Five small jobs, each switched on only when its markup is on the page:
     nav       the Product menu, the language menu and the phone menu
     langs     language links that keep you on the page you are reading
     reveal    a 6px rise and a fade as a block scrolls in — the only motion
     film      the hero film starts with sound when somebody asks for it
     matrix    the size-and-colour grid, one department at a time

   gfc_site.bundle.js still loads on every web page; it finds none of the old
   navigation's hooks here and leaves this chrome alone. */
(function () {
	if (window.__GB_BRAND__) return;
	window.__GB_BRAND__ = 1;
	document.documentElement.classList.add("gb-js");

	var reduce =
		window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	/* -- nav ------------------------------------------------------------------- */

	function nav() {
		var bar = document.querySelector(".gb-nav");
		if (!bar) return;

		var onScroll = function () {
			bar.classList.toggle("is-scrolled", window.scrollY > 8);
		};
		onScroll();
		window.addEventListener("scroll", onScroll, { passive: true });

		// One open menu at a time; Escape and a click elsewhere close it.
		var menus = [];
		function menu(button, panel) {
			if (!button || !panel) return;
			var m = {
				button: button,
				panel: panel,
				set: function (open) {
					button.setAttribute("aria-expanded", open ? "true" : "false");
					panel.hidden = !open;
				},
			};
			button.addEventListener("click", function (e) {
				e.stopPropagation();
				var open = button.getAttribute("aria-expanded") !== "true";
				menus.forEach(function (other) {
					if (other !== m) other.set(false);
				});
				m.set(open);
			});
			menus.push(m);
		}
		menu(document.getElementById("gbMegaBtn"), document.getElementById("megaFeatures"));
		menu(bar.querySelector(".gb-lang__btn"), document.getElementById("gbLangMenu"));

		function closeAll() {
			menus.forEach(function (m) {
				m.set(false);
			});
		}
		document.addEventListener("click", function (e) {
			if (!e.target.closest(".gb-mega, .gb-lang__menu")) closeAll();
		});

		var burger = document.getElementById("gbBurger");
		function setOpen(open) {
			bar.classList.toggle("is-open", open);
			if (burger) burger.setAttribute("aria-expanded", open ? "true" : "false");
			document.documentElement.style.overflow = open ? "hidden" : "";
		}
		if (burger) {
			burger.addEventListener("click", function () {
				setOpen(!bar.classList.contains("is-open"));
			});
		}
		document.addEventListener("keydown", function (e) {
			if (e.key !== "Escape") return;
			closeAll();
			setOpen(false);
		});
		// Leaving the phone layout with the menu open would leave the page unscrollable.
		window.addEventListener("resize", function () {
			if (window.innerWidth > 1080 && bar.classList.contains("is-open")) setOpen(false);
		});
	}

	/* -- language links -------------------------------------------------------- */

	/* The language lives in the URL: /es/costing is Spanish for everybody. Only routes
	   that exist in every language may be prefixed (i18n.TRANSLATED_ROUTES, rendered into
	   #gfLocaleRoutes); anything else stays where it is rather than 404ing. Choosing one
	   also switches off gfc_site.bundle.js's first-visit guess for the rest of the visit. */
	var PREFIXES = ["es", "pt", "zh"];

	function routes() {
		try {
			var el = document.getElementById("gfLocaleRoutes");
			return el ? JSON.parse(el.textContent) || [] : [];
		} catch (e) {
			return [];
		}
	}

	function langs() {
		var parts = location.pathname.split("/").filter(Boolean);
		var current = PREFIXES.indexOf(parts[0]) >= 0 ? parts.shift() : "en";
		var route = "/" + parts.join("/");
		var known = route === "/" || routes().indexOf(route) >= 0;

		document.querySelectorAll("[data-gb-lang]").forEach(function (a) {
			var lang = a.getAttribute("data-gb-lang");
			var href = route;
			if (known && lang !== "en") href = route === "/" ? "/" + lang : "/" + lang + route;
			a.setAttribute("href", href + location.search);
			if (lang === current) a.setAttribute("aria-current", "true");
			else a.removeAttribute("aria-current");
			a.addEventListener("click", function () {
				try {
					localStorage.setItem("gf-lang", lang);
					sessionStorage.setItem("gf-chose", "1");
				} catch (e) {
					/* storage refused — the choice is simply not remembered */
				}
			});
		});

		var label = document.querySelector(".gb-lang__btn span");
		if (label) label.textContent = current.toUpperCase();

		// On a translated page, the links to other translated pages stay in its language:
		// "/production" on /es is /es/production. Anything not in every language (/signup,
		// /docs, /login) is left alone rather than sent to a 404.
		if (current === "en") return;
		var knownRoutes = routes();
		document.querySelectorAll("a[href^='/']:not([data-gb-lang])").forEach(function (a) {
			var raw = a.getAttribute("href");
			var m = raw.match(/^([^?#]*)(.*)$/);
			var path = m[1].replace(/\/+$/, "") || "/";
			var first = path.split("/").filter(Boolean)[0];
			if (PREFIXES.indexOf(first) >= 0) return;
			if (path !== "/" && knownRoutes.indexOf(path) < 0) return;
			a.setAttribute("href", (path === "/" ? "/" + current : "/" + current + path) + m[2]);
		});
	}

	/* -- reveal ---------------------------------------------------------------- */

	function reveal() {
		var items = [].slice.call(document.querySelectorAll(".gb-reveal"));
		if (!items.length) return;
		if (reduce || !("IntersectionObserver" in window)) {
			items.forEach(function (el) {
				el.classList.add("in");
			});
			return;
		}
		var io = new IntersectionObserver(
			function (entries) {
				entries.forEach(function (e) {
					if (!e.isIntersecting) return;
					e.target.classList.add("in");
					io.unobserve(e.target);
				});
			},
			{ rootMargin: "0px 0px -8% 0px" }
		);
		items.forEach(function (el) {
			io.observe(el);
		});
	}

	/* -- film ------------------------------------------------------------------ */

	/* The film opens in a lightbox. Nothing downloads until somebody asks for it
	   (preload="none"); then it plays with sound. Closing stops it, so it never carries
	   on talking behind the page. A click on the backdrop closes it too. */
	function film() {
		var box = document.getElementById("gbFilm");
		var open = document.querySelector("[data-gb-film-open]");
		if (!box || !open || typeof box.showModal !== "function") return;
		var video = box.querySelector("video");

		open.addEventListener("click", function () {
			box.showModal();
			if (video) {
				var p = video.play();
				if (p && p.catch) p.catch(function () {});
			}
		});
		box.addEventListener("close", function () {
			if (video) video.pause();
		});
		box.addEventListener("click", function (e) {
			if (e.target === box || e.target.closest("[data-gb-film-close]")) box.close();
		});
	}

	/* -- the size-and-colour grid ---------------------------------------------- */

	/* The cells are rendered for the Tech pack view, so the grid reads without script.
	   Each tab swaps the numbers for what that department sees in the same 24 cells, and
	   the tabs step on by themselves until somebody chooses one — or until the grid has
	   scrolled out of sight, so nothing ticks over unseen. */
	function matrix() {
		var box = document.querySelector("[data-gb-matrix]");
		if (!box) return;
		var views;
		try {
			views = JSON.parse(box.getAttribute("data-gb-matrix"));
		} catch (e) {
			return;
		}
		var tabs = [].slice.call(document.querySelectorAll(".gb-tab[data-view]"));
		var cells = [].slice.call(box.querySelectorAll("td[data-i]"));
		var cap = box.querySelector(".gb-matrix__cap");
		var byKey = {};
		views.forEach(function (v) {
			byKey[v.key] = v;
		});

		function esc(s) {
			return String(s).replace(/[&<>"]/g, function (c) {
				return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
			});
		}

		function show(key) {
			var v = byKey[key];
			if (!v) return;
			tabs.forEach(function (t) {
				var on = t.getAttribute("data-view") === key;
				t.setAttribute("aria-selected", on ? "true" : "false");
				t.tabIndex = on ? 0 : -1;
				if (on) box.setAttribute("aria-labelledby", t.id);
			});
			cells.forEach(function (td) {
				var i = +td.getAttribute("data-i");
				var val = v.cells[i];
				var empty = val === null || val === undefined;
				td.classList.toggle("empty", empty);
				td.classList.toggle("hot", i === v.hot && !empty);
				td.innerHTML = empty
					? "—"
					: esc(val) + (v.unit ? "<small>" + esc(v.unit) + "</small>" : "");
			});
			if (cap) cap.textContent = v.caption;
		}

		var order = tabs.map(function (t) {
			return t.getAttribute("data-view");
		});
		var at = order.indexOf("bom");
		var timer = null;
		var chosen = false;
		var visible = false;

		function tick() {
			at = (at + 1) % order.length;
			show(order[at]);
		}
		function run() {
			if (timer || chosen || reduce || !visible) return;
			timer = setInterval(tick, 3600);
		}
		function stop() {
			clearInterval(timer);
			timer = null;
		}

		tabs.forEach(function (t, i) {
			t.addEventListener("click", function () {
				chosen = true;
				stop();
				at = i;
				show(order[i]);
			});
			t.addEventListener("keydown", function (e) {
				var d = e.key === "ArrowRight" ? 1 : e.key === "ArrowLeft" ? -1 : 0;
				if (!d) return;
				e.preventDefault();
				var n = (i + d + tabs.length) % tabs.length;
				tabs[n].focus();
				tabs[n].click();
			});
		});
		show(order[at]);

		if ("IntersectionObserver" in window) {
			new IntersectionObserver(function (entries) {
				visible = entries[0].isIntersecting;
				if (visible) run();
				else stop();
			}).observe(box);
		}
	}

	/* -- five into one -------------------------------------------------------- */

	/* The five subscriptions merge into GarmentFlow: each tile's name flies along its
	   line into the card and lands there as a chip, then the grid fills and the card
	   lights. Once, on sight. The finished state is what the markup and CSS show by
	   themselves, so with reduced motion, no script or no Web Animations nothing is lost. */
	function merge() {
		var map = document.querySelector("[data-gb-merge]");
		if (!map || reduce || !("IntersectionObserver" in window) || !map.animate) return;

		var tiles = [].slice.call(map.querySelectorAll(".gb-tile"));
		var chips = map.querySelectorAll(".gb-one__chips li");
		var cells = [].slice.call(map.querySelectorAll(".gb-mini i"));
		map.classList.add("is-ready");

		function fill() {
			cells.forEach(function (cell, k) {
				setTimeout(function () {
					cell.classList.add("lit");
					if (k === cells.length - 1) map.classList.add("is-merged");
				}, k * 28);
			});
		}

		function fly(i) {
			var tile = tiles[i];
			var chip = chips[i];
			var path = map.querySelector('.gb-five__lines path[data-i="' + i + '"]');
			if (path) path.classList.add("is-on");
			tile.classList.add("is-in");
			if (!chip) return;

			var base = map.getBoundingClientRect();
			var from = tile.querySelector("b").getBoundingClientRect();
			var to = chip.getBoundingClientRect();
			var ghost = document.createElement("span");
			ghost.className = "gb-ghost";
			ghost.textContent = chip.textContent;
			ghost.style.left = from.left - base.left + "px";
			ghost.style.top = from.top - base.top - 5 + "px";
			map.appendChild(ghost);

			var dx = to.left - from.left;
			var dy = to.top - from.top + 5;
			var flight = ghost.animate(
				[
					{ transform: "translate(0, 0) scale(1.08)" },
					{ transform: "translate(" + dx + "px, " + dy + "px) scale(1)" },
				],
				{ duration: 700, easing: "cubic-bezier(0.2, 0.7, 0.2, 1)" }
			);
			flight.onfinish = function () {
				ghost.remove();
				chip.classList.add("is-in");
				if (i === tiles.length - 1) fill();
			};
		}

		var io = new IntersectionObserver(
			function (entries) {
				if (!entries[0].isIntersecting) return;
				io.disconnect();
				tiles.forEach(function (tile, i) {
					setTimeout(function () {
						fly(i);
					}, 250 + i * 320);
				});
			},
			{ threshold: 0.45 }
		);
		io.observe(map);
	}

	/* -- the device word ------------------------------------------------------ */

	/* Flips the Apps heading's keyword through the devices GarmentFlow runs on. Only while
	   it is on screen, held while the pointer is over it, and two rounds at most — it
	   comes to rest on the first word, so nothing on the page moves for ever. Nothing
	   moves at all for anybody who has asked for reduced motion. */
	function rotor() {
		var host = document.querySelector("[data-gb-rotor]");
		var word = host && host.querySelector(".gb-rotor__w");
		if (!word || reduce) return;
		var words;
		try {
			words = JSON.parse(host.getAttribute("data-gb-rotor"));
		} catch (e) {
			return;
		}
		if (!words || words.length < 2) return;

		var at = 0;
		var flips = 0;
		var limit = words.length * 2;
		var timer = null;

		function flip() {
			if (flips >= limit) return stop();
			word.classList.add("is-out");
			setTimeout(function () {
				at = (at + 1) % words.length;
				flips += 1;
				word.textContent = words[at];
				word.classList.remove("is-out");
				word.classList.add("is-in");
				void word.offsetWidth; // commit the start angle before turning back
				word.classList.remove("is-in");
			}, 230);
		}
		function start() {
			if (!timer && flips < limit) timer = setInterval(flip, 2000);
		}
		function stop() {
			clearInterval(timer);
			timer = null;
		}

		host.addEventListener("mouseenter", stop);
		host.addEventListener("mouseleave", start);
		if ("IntersectionObserver" in window) {
			new IntersectionObserver(function (entries) {
				if (entries[0].isIntersecting) start();
				else stop();
			}).observe(host);
		} else {
			start();
		}
	}

	function start() {
		nav();
		langs();
		reveal();
		film();
		matrix();
		merge();
		rotor();
	}
	if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
	else start();
})();
